import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';

import { DialogListProps } from '../../types';

function List(props: DialogListProps) {
  const { className, items } = props;

  return (
    <Box className={cn('px-32', className)}>
      {items.map((item, index) => {
        const { Icon, text, primaryText } = item;
        return (
          <Stack key={index} alignItems="center" className="mb-16">
            {Icon ? (
              <Box className="me-12">
                <Icon className="h-20 w-20 text-icon-primary" />
              </Box>
            ) : null}
            <Typography color="text-text-paragraph" variant="body-short-02">
              {primaryText ? (
                <Typography className="pe-6" variant="heading-xxs">
                  {primaryText}
                </Typography>
              ) : null}
              {text}
            </Typography>
          </Stack>
        );
      })}
    </Box>
  );
}

export default List;
